import { Component, OnInit, OnDestroy, Inject } from "@angular/core";

import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_AUTH } from '@okta/okta-angular';
import {Router} from "@angular/router";

@Component({
    selector: "oktauser-navigation",
    template: ``,
    standalone: false
})
export class OktaUserNavigationComponent implements OnInit, OnDestroy {
    private accessToken:any;
    constructor(
    protected configService: AppConfigService,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private router: Router,
  ) {
      this.accessToken = JSON.parse(localStorage.getItem('okta-token-storage')); 
    }

  async ngOnInit() {
    
    const authenticated = await this.oktaAuth.isAuthenticated();
    if(authenticated)
    {
      let groupName = this.accessToken.accessToken.claims.group; 
      if (groupName.indexOf('TmhccOKTA-PAPI-Admin-Weather-UW-NonProd') > 0)      
         this.router.navigate(["/wuw-dashboard"]);      
      else
         this.router.navigate(["/dashboard"]); 
    }
    else  
    this.router.navigate(["/dashboard"]);       
  }

  ngOnDestroy() {}
}
